import { getService } from 'data/function';
export class ApplicationRequestProcessor2 {
    static get ApplicationService2() {
        return getService('ApplicationService2');
    }
    static async process({ message, trackingProperties, source }) {
        try {
            const method = message.content && message.content.method;
            const args = message.content && message.content.args;
            const response = await ApplicationRequestProcessor2.ApplicationService2[method](args);
            const messageResponse = {
                response,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
